<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-property-detail class="flex" [property]="property" (close)="onClose($event)">
  </app-property-detail>
</div>
